import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import {
    BridgeWebhookEndpoint,
    CreateWebhookEndpointRequest,
    UpdateWebhookEndpointRequest,
    WebhookDeliveryLog
} from "../../../models/bridge/bridge-webhook.model";
import { BridgeBaseService } from "./bridge-base.service";

/**
 * Service for 4Bridge Webhook Endpoints API
 */
@Injectable({
    providedIn: 'root'
})
export class BridgeWebhookService extends BridgeBaseService<BridgeWebhookEndpoint> {

    constructor(httpClient: HttpClient) {
        super(httpClient, 'webhooks');
    }

    /**
     * Create a new webhook endpoint
     */
    public createWebhook(request: CreateWebhookEndpointRequest): Observable<BridgeWebhookEndpoint> {
        return this.create(request as any);
    }

    /**
     * Update an existing webhook endpoint
     */
    public updateWebhook(id: string, request: UpdateWebhookEndpointRequest): Observable<BridgeWebhookEndpoint> {
        return this.update(id, request as any);
    }

    /**
     * Test a webhook endpoint
     */
    public testWebhook(id: string): Observable<any> {
        return this.httpClient
            .post(`${this.baseUrl}/${this.endpoint}/${id}/test`, {})
            .pipe(
                catchError((error) => this.handleError(error))
            );
    }

    /**
     * Get delivery logs for a webhook endpoint
     */
    public getDeliveryLogs(id: string): Observable<WebhookDeliveryLog[]> {
        return this.httpClient
            .get<WebhookDeliveryLog[]>(`${this.baseUrl}/${this.endpoint}/${id}/logs`)
            .pipe(
                catchError((error) => this.handleError(error))
            );
    }

    /**
     * Regenerate webhook secret
     */
    public regenerateSecret(id: string): Observable<BridgeWebhookEndpoint> {
        return this.httpClient
            .post<BridgeWebhookEndpoint>(`${this.baseUrl}/${this.endpoint}/${id}/regenerate-secret`, {})
            .pipe(
                catchError((error) => this.handleError(error))
            );
    }
}
